import { gql } from "@apollo/client";
import {
  Container,
  Skeleton,
  Typography,
} from "@mui/material";

import { useApiKeysQuery } from "~/graphql/__generated__/graphql";
import ApiKeys from "./ApiKeys";

const TabApiKeys = () => {
  const { data, loading, error } = useApiKeysQuery();

  if (error) {
    return <Typography color="error">Error loading API keys</Typography>;
  }

  return <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
    {loading ? <>
      <Skeleton width="100%" height={75} />
      <Skeleton width="100%" />
      <Skeleton width="100%" />
      <Skeleton width="100%" />
    </> : <ApiKeys apiKeys={data?.apiKey || []} />}
  </Container>;
};

export default TabApiKeys;

gql`
  query ApiKeys
  @permission(requires: manageApiKeys) {
    apiKey {
      id
      apiKey
      keyPurpose
      algorithm
      organizationUser {
        user {
          firstName
          lastName
        }
      }
      expiresAt
      createdAt
      createdByUser {
        firstName
        lastName
      }
      updatedAt
    }

    webhookEndpoint {
      id
      eventType
      url
      apiKeyId
    }
  }
`;
